export default __webpack_public_path__ + "images/1d2d13d3ee58afd0934383cdc8a4bdf7.svg";